import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { FormaPagoService } from '../../../services/FormaPagoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'forma_pago',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. 03',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'forma_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Ej. Transferencia electrónica de fondos',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const FormaPagoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await FormaPagoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await FormaPagoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Forma de Pago"
      subtitle="Catálogo de formas de pago SAT"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/FormasPago"
    />
  );
};

export default FormaPagoForm;
